import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "wouter";
import { 
  Newspaper, 
  FileText, 
  ArrowRight,
  PenTool,
  Sparkles,
} from "lucide-react";

export default function ContentStudio() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold" data-testid="text-content-studio-title">Content Studio</h1>
        <p className="text-muted-foreground">
          Create and manage your content submissions
        </p>
      </div>

      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        <Card className="hover-elevate cursor-pointer">
          <Link href="/dashboard/press-releases">
            <CardHeader>
              <div className="flex h-12 w-12 items-center justify-center rounded-md bg-primary/10 mb-2">
                <Newspaper className="h-6 w-6 text-primary" />
              </div>
              <CardTitle className="text-base">Press Releases</CardTitle>
              <CardDescription>
                Create professional press releases for product announcements
              </CardDescription>
            </CardHeader>
            <CardContent>
              <Button variant="outline" className="w-full" data-testid="button-press-releases">
                Create Press Release
                <ArrowRight className="h-4 w-4 ml-2" />
              </Button>
            </CardContent>
          </Link>
        </Card>

        <Card className="opacity-60">
          <CardHeader>
            <div className="flex h-12 w-12 items-center justify-center rounded-md bg-muted mb-2">
              <FileText className="h-6 w-6 text-muted-foreground" />
            </div>
            <CardTitle className="text-base">Articles</CardTitle>
            <CardDescription>
              Submit articles and news stories for publication
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Button variant="outline" className="w-full" disabled>
              Coming Soon
            </Button>
          </CardContent>
        </Card>

        <Card className="opacity-60">
          <CardHeader>
            <div className="flex h-12 w-12 items-center justify-center rounded-md bg-muted mb-2">
              <Sparkles className="h-6 w-6 text-muted-foreground" />
            </div>
            <CardTitle className="text-base">AI Writing Assistant</CardTitle>
            <CardDescription>
              Get AI-powered help with your content creation
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Button variant="outline" className="w-full" disabled>
              Coming Soon
            </Button>
          </CardContent>
        </Card>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-base">
            <PenTool className="h-5 w-5" />
            Content Guidelines
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-3 text-sm text-muted-foreground">
          <p>
            All content submissions go through our editorial review process before publication.
          </p>
          <ul className="list-disc list-inside space-y-1">
            <li>Content must be factually accurate and professionally written</li>
            <li>Include all relevant contact information</li>
            <li>Press releases should follow standard industry format</li>
            <li>Editorial team may make minor edits for clarity</li>
          </ul>
          <p className="text-xs">
            Submissions typically reviewed within 2-3 business days.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
